import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import PromotionalBannerList from '../components/promotionalBanners/PromotionalBannerList';
import PromotionalBannerForm from '../components/promotionalBanners/PromotionalBannerForm';

const PromotionalBanners = ({ onLogout }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const toggleFormCanvas = () => {
    setIsFormOpen(!isFormOpen);
    if (!isFormOpen) {
      setSelectedBanner(null); // Reset when opening for new banner
    }
  };

  const handleCreateSuccess = () => {
    setRefreshKey(prevKey => prevKey + 1);
    setSelectedBanner(null);
  };

  const handleEdit = (banner) => {
    setSelectedBanner(banner);
    setIsFormOpen(true);
  };

  const handleClose = () => {
    setIsFormOpen(false);
    setSelectedBanner(null);
  };

  return (
    <div className='d-flex w-100 overflow-hidden'>
      <div className='asidebar'>
        <Sidebar />
      </div>
      <div className='main-content'>
        <div className='d-flex align-items-center justify-content-between mb-4'>
          <div>
            <h2>Promotional Banners</h2>
            <p className="text-muted mb-0">Manage promotional banners displayed in the app</p>
          </div>
          <button
            type="button"
            className="btn btn-primary rounded-pill px-4"
            onClick={toggleFormCanvas}
            style={{
              height: '50px',
              fontWeight: '600',
              border: 'none',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              minWidth: '180px'
            }}
          >
            {selectedBanner ? 'Edit Banner' : 'Create New Banner'}
          </button>
        </div>

        <PromotionalBannerList 
          key={refreshKey} 
          refreshKey={refreshKey}
          onEdit={handleEdit}
        />

        <Offcanvas 
          isOpen={isFormOpen} 
          toggle={toggleFormCanvas} 
          className="custom-canvas-width" 
          direction='end'
        >
          <OffcanvasHeader 
            className='mb-4 mx-4 mt-2 border-bottom' 
            toggle={toggleFormCanvas}
          >
            <span className='font-weight-bold'>
              {selectedBanner ? 'Edit Promotional Banner' : 'Create New Promotional Banner'}
            </span>
          </OffcanvasHeader>
          <OffcanvasBody style={{ padding: 0 }}>
            <PromotionalBannerForm 
              banner={selectedBanner}
              onClose={handleClose}
              onSuccess={handleCreateSuccess}
            />
          </OffcanvasBody>
        </Offcanvas>
      </div>
    </div>
  );
};

export default PromotionalBanners;
